module.exports = __webpack_public_path__ + "assets/img/1701589512664_.pic_hd.027cfebc.jpg";